import './default_module'
import { redirectAsPost } from 'javascripts/general_scripts'

window.redirectAsPost = redirectAsPost;

/* stylesheet */
import 'stylesheets/users/points.less'